import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 loader.
 *
 * Reads the measurement ID from REACT_APP_GA4_ID (e.g. "G-XXXXXXXXXX").
 * If the env var is empty, GA4 is not loaded — safe to keep in production.
 *
 * Tracks SPA route changes automatically.
 */
const GA_ID = process.env.REACT_APP_GA4_ID;

export default function Analytics() {
  const { pathname, search } = useLocation();

  // Inject gtag.js once
  useEffect(() => {
    if (!GA_ID) return;
    if (window.__ga_loaded__) return;
    window.__ga_loaded__ = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID, { send_page_view: false });
  }, []);

  // Track SPA route changes
  useEffect(() => {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
